"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get GetCurrentPulseMetaResponse () {
        return GetCurrentPulseMetaResponse;
    },
    get GetEngagementNotificationResponse () {
        return GetEngagementNotificationResponse;
    },
    get GetEngagementQuestionResponse () {
        return GetEngagementQuestionResponse;
    }
});
const _bson = require("bson");
const _zod = require("zod");
const GetEngagementNotificationResponse = _zod.z.object({
    employee: _zod.z.instanceof(_bson.ObjectID),
    company: _zod.z.instanceof(_bson.ObjectID),
    daysUntilNextSurvey: _zod.z.number().nullable(),
    accessKey: _zod.z.string(),
    surveyForm: _zod.z.instanceof(_bson.ObjectID)
});
const GetEngagementQuestionResponse = _zod.z.object({
    question: _zod.z.string()
});
const GetCurrentPulseMetaResponse = _zod.z.discriminatedUnion("state", [
    // Disabled state - engagement is not enabled
    _zod.z.object({
        state: _zod.z.literal("disabled")
    }),
    // Not started state - engagement is enabled but no survey exists yet
    _zod.z.object({
        state: _zod.z.literal("not_started")
    }),
    // Active state - there's an active survey
    _zod.z.object({
        state: _zod.z.literal("active"),
        currentPulseId: _zod.z.instanceof(_bson.ObjectID),
        closingDate: _zod.z.date().optional(),
        startDate: _zod.z.date(),
        nextSurveyDate: _zod.z.date().nullable(),
        status: _zod.z.enum([
            "open",
            "closed",
            "expired"
        ]).optional(),
        closedAt: _zod.z.date().nullable(),
        totalParticipants: _zod.z.number(),
        participantsWhoAnswered: _zod.z.number(),
        totalQuestions: _zod.z.number(),
        totalAnsweredQuestions: _zod.z.number()
    })
]);
